const getColorByHex = (
	color: string,
): 'green' | 'blue' | 'darkBlue' | 'red' => {
	if (color === '#8CF07E') {
		return 'green';
	}
	if (color === '#1AB0E6') {
		return 'blue';
	}
	if (color === '#5082C2') {
		return 'darkBlue';
	}
	if (color === '#C22A58') {
		return 'red';
	}

	return 'green';
};

export type colorsHex = '#8CF07E' | '#1AB0E6' | '#5082C2' | '#C22A58';

export type colorsNames = 'green' | 'blue' | 'darkBlue' | 'red';

export type dateScheduled = {
	color: colorsHex;
	date: string;
};

export type formattedDateScheduleObject = {
	colorName: colorsNames;
	date: string;
};

export type FormattedDatesResult = undefined | formattedDateScheduleObject[];

export const getFormattedDatesSchedules = (
	datesScheduled: dateScheduled[],
): FormattedDatesResult => {
	if (datesScheduled.length) {
		return datesScheduled.map((dateScheduled: dateScheduled) => ({
			colorName: getColorByHex(dateScheduled.color.toUpperCase()),
			date: dateScheduled.date,
		}));
	}

	return undefined;
};
